<script>
import Vue from 'vue'
const EventBus = new Vue() 

export default EventBus
</script>


// WEBPACK FOOTER //
// src/components/EventBus.vue